import React from "react";
import { Trophy, Vote, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

/* Optional: Indian number formatter */
const formatIndianNumber = (num) =>
  num?.toLocaleString("en-IN") || 0;

const rankColors = {
  1: "text-green-600",
  2: "text-blue-600",
  3: "text-yellow-600",
};

const ElectionResultCard = ({ surveyType,result, party }) => {
  const { t } = useTranslation();
  if (!result) return null;

  return (
    <div className="absolute top-[26%] right-2 p-1 card-wrapper !rounded-xl w-[320px] z-[20]">

      {/* HEADER */}
      <h3 className="text-lg font-semibold text-center text-[#123865] mb-1">
         {t("electionResult")} - {party}
      </h3>
      
      {/* RANK HIGHLIGHT */}
      <div className="card-wrapper !rounded-xl px-3 py-2 mb-2 shadow-sm text-center">
        <div className="flex items-center justify-center gap-1 text-sm text-gray-600">
          <Trophy size={14} />
         {t("rank")}
        </div>
        <div
          className={`text-2xl font-bold ${
            rankColors[result.rank] || "text-[#0b65c2]"
          }`}
        >
          #{result.rank}
        </div>
      </div>

      {/* VOTE SHARE */}
      <div className="card-wrapper !rounded-xl px-3 py-2 mb-1 shadow-sm text-center">
        <div className="text-sm text-gray-600">{t("voteShare")}</div>
        <div className="text-lg font-semibold text-[#0b65c2]">
          {formatIndianNumber(result.voteShare)}
        </div>
        <div className="text-xs text-gray-500">
          {result.voteSharePercent}%
        </div>
      </div>

      {/* PS / VILLAGES */}
      <div className="card-wrapper !rounded-xl px-2 py-2 shadow-sm">
        <div className="text-sm font-medium text-gray-700 mb-2 text-center">
          {t("performanceSpread")}
        </div>

        {(surveyType==='assembly' ||surveyType==='parliamentary')  && <div className="flex justify-around items-center text-sm font-semibold">
          <div className="flex flex-col items-center">
            <Vote size={14} className="text-[#0b65c2]" />
            <span className="text-gray-600 mt-1">PS Won</span>
            <span className="text-[#0b65c2]">{result.psWon}</span>
          </div>

          <div className="flex flex-col items-center">
            <MapPin size={14} className="text-green-600" />
            <span className="text-gray-600 mt-1">{surveyType==='assembly'? "Villages":"Assemblies"}</span>
            <span className="text-green-600">
              {surveyType==='assembly' && result.villages?.villagesWonCount || 0}
              {surveyType==='parliamentary' && result.constituencies?.constituenciesWonCount || 0}
            </span>
          </div>
        </div>}
        {surveyType==='state' && 
          <div className="flex justify-around items-center text-sm font-semibold">
            <div className="flex flex-col items-center">
              <Vote size={14} className="text-[#0b65c2]" />
              <span className="text-gray-600 mt-1">{t("assembliesWon")}</span>
              <span className="text-[#0b65c2]">{result.assembliesWon}</span>
            </div>
        </div>
        }
      </div>
    </div>
  );
};

export default ElectionResultCard;
